// extracted by mini-css-extract-plugin
export default {"container":"CreateBoxes_container__Euxma","box":"CreateBoxes_box__T+33q","icon":"CreateBoxes_icon__h92VG"};